<template>
  <CModal
    v-model:visible="show"
    title="Request Email Change"
    color="primary"
    @close="close"
  >
    <form
      autocomplete="off"
      @submit.prevent="submit"
    >
      <p class="text-muted">
        A verification link will be sent to your current email to authorize this change.
      </p>
      <CInput
        v-model="new_email"
        label="New Email Address"
        type="email"
        :add-input-classes="{ 'is-invalid': hasError('new_email') }"
        :invalid-feedback="getError('new_email')"
        placeholder="Enter new email"
      />
    </form>
    <template #footer>
      <CButton
        color="secondary"
        :disabled="loading"
        @click="close"
      >
        Cancel
      </CButton>
      <CButton
        color="primary"
        :disabled="loading || !new_email"
        @click="submit"
      >
        <CSpinner
          v-if="loading"
          size="sm"
          class="mr-1"
        />
        Request Change
      </CButton>
    </template>
  </CModal>
</template>

<script>
import hasApiValidation from '@/mixins/hasApiValidation';

export default {
  name: 'ChangeEmailModal',
  mixins: [hasApiValidation],
  data() {
    return {
      show: false,
      new_email: '',
      loading: false,
    };
  },
  methods: {
    open() {
      this.new_email = '';
      this.setErrors({});
      this.show = true;
    },
    close() {
      this.show = false;
    },
    handleShowUpdate(val) {
      if (!val) this.close();
    },
    submit() {
      this.setErrors({});
      this.loading = true;

      this.$http
        .post('/me/email-change', {
          new_email: this.new_email,
        })
        .then(({ data }) => {
          this.$toast.success(data.message || 'Verification email sent!');
          this.close();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message || 'An error occurred');
          if (response.data.errors) {
            this.setErrors(response.data.errors);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
